import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import {
  ChipsRow,
  ChipGroup,
  MetaChip,
  ChipLabel,
  ChipValue,
} from "./Chips";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Pencil,
  ClockHistory,
  ChevronDown,
  ChevronUp,
  CheckCircleFill,
  Person,
  Cart3,
} from "react-bootstrap-icons";

import { getPhotoForUserId } from "../../utils/utils";
import { idx_data_axistilt } from "../db/datafixtures/datafixtures";
import {
  setCustomer,
  papGetAuditRecords,
  deleteCustomer,
  setCustomerPhoto,
} from "../bowlers/bowlers.redux";
import {
  woocommerceCheckUserExists,
  woocommerceCreateCustomer,
  woocommerceUpdateCustomer,
  resetErrorMessage,
} from "../plugins/plugin.redux";
import { specsheetSVGClick } from "../specsheet/specsheet.redux";
import UpdateProfile from "./UpdateProfile";
import PhotoSelect from "./PhotoSelect";
import ConfirmDelete from "./ConfirmDelete";
import BowlerDataModal from "./BowlerDataModal";
import ModalPAPAudit from "../modal/ModalPAPAudit";
import ModalMotionMeasurements from "../modal/ModalMotionMeasurements";
import { getMotionMeasurements } from "../motion/motionApi";
import ModalUpdateError from "../modal/ModalUpdateError";
import { ModalSpecsheets } from "../modal/ModalSpecsheets";
import { posLinkLabel } from "../../utils/posLink";

const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #eef0f5;
  box-shadow: 0 1px 3px rgba(16, 24, 64, 0.06);
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;

  @media only screen and (min-width: 768px) {
    padding-right: 64px;
    padding-bottom: 8px;
  }

  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
    justify-content: center;
    text-align: center;
  }
`;

const CollapseTab = styled.button`
  position: absolute;
  left: 50%;
  bottom: -12px;
  transform: translateX(-50%);
  background: #ffffff;
  border: 1px solid #eef0f5;
  border-radius: 999px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #00187e;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(16, 24, 64, 0.08);
  z-index: 1001;

  &:hover {
    background: #f5f6fa;
  }

  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const Avatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
  background: #f0f1f6;

  @media (max-width: 767px) {
    ${(props) => props.$collapsed && "display: none;"}
  }
`;

const AvatarFallback = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #00187e;
  color: #ffffff;
  font: 700 20px Poppins, sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  @media (max-width: 767px) {
    ${(props) => props.$collapsed && "display: none;"}
  }
`;

const CustomerBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 0 1 30%;

  @media only screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
    flex: 1 1 100%;
  }

  @media (max-width: 767px) {
    flex: 1 1 100%;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
  flex: 1 1 auto;
  column-gap: 14px;
  row-gap: 2px;

  @media (max-width: 767px) {
    flex: 1 1 100%;
    justify-content: center;
    text-align: center;
  }
`;

const NameLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 0 1 auto;

  @media (max-width: 767px) {
    justify-content: center;
    width: 100%;
  }
`;

const NameText = styled.span`
  font-weight: 700;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

const PrimaryLine = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  row-gap: 0;
  min-width: 0;
  flex: 1 1 auto;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    justify-content: center;
    width: 100%;
  }
`;

const PersonalLine = styled.span`
  font-size: 11px;
  color: rgba(0, 0, 0, 0.55);
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  color: #00187e;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  flex: 0 0 auto;

  &:hover {
    background: rgba(0, 24, 126, 0.08);
  }
`;

const Actions = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
  max-width: 55%;
`;

export const HeaderActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #00187e;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;

  &:hover {
    background: #001463;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${(props) =>
    props.secondary &&
    css`
      background: transparent;
      color: #00187e;
      border: 1px solid #c3c7d4;

      &:hover {
        background: rgba(0, 24, 126, 0.08);
      }
    `}

  ${(props) =>
    props.danger &&
    css`
      background: transparent;
      color: #d33;
      border: 1px solid #fdd;

      &:hover {
        background: #fee;
      }
    `}
`;

const PosBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e6f8fa;
  color: #00187e;
  font-size: 10px;
  font-weight: 700;
  border: 1px solid #00becc;
  letter-spacing: 0.3px;
  white-space: nowrap;
  flex: 0 0 auto;

  svg {
    width: 11px;
    height: 11px;
    color: #00becc;
  }
`;

// Same shape as PosBadge, in the amber of something still to be charged.
const OrderBadge = styled(PosBadge)`
  background: #fff4e0;
  color: #7a4a00;
  border-color: #f0a020;

  svg {
    color: #c77700;
  }
`;

// On a phone the name is what must stay readable: the cart and the count say it.
const OrderLabel = styled.span`
  @media (max-width: 767px) {
    display: none;
  }
`;

const HandPill = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 999px;
  background: #e7eaf6;
  color: #00187e;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  border: none;
  white-space: nowrap;
  cursor: ${(props) => (props.$readonly ? "default" : "pointer")};
  flex: 0 0 auto;

  &:hover {
    background: ${(props) => (props.$readonly ? "#e7eaf6" : "#d8defa")};
  }
`;

const PosDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00becc;
  display: inline-block;
`;

const BowlerHeaderImpl = ({
  bowler,
  userId,
  isReadOnly,
  pluginSubscriptions,
  posOpenOrder,
  isRightHander,
  setCustomer,
  papGetAuditRecords,
  deleteCustomer,
  woocommerceCheckUserExists,
  woocommerceCreateCustomer,
  woocommerceUpdateCustomer,
  resetErrorMessage,
  specsheetSVGClick,
  setCustomerPhoto,
  savingPhoto,
  require_signature,
  require_email,
  require_phone,
  current_woocommerce_id,
  errorMessage,
  actions,
  children,
  autoOpenIfIncomplete = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showEditProfileModal, setShowEditProfileModal] = useState(
    autoOpenIfIncomplete &&
      !!bowler &&
      (bowler.firstname === "" ||
        bowler.lastname === "" ||
        (require_email === true && bowler.email === "") ||
        (require_phone === true && bowler.telephone === ""))
  );
  const [showBowlerData, setShowBowlerData] = useState(false);
  // Spectre Motion (the sensor app): the sets measured for this bowler. Only
  // fetched when the account has the plugin; the chip stays out otherwise.
  const hasMotion = pluginSubscriptions.indexOf("BALL_MOTION") >= 0;
  const [motionMeasurements, setMotionMeasurements] = useState(null);
  const [showMotion, setShowMotion] = useState(false);
  useEffect(() => {
    let alive = true;
    setMotionMeasurements(null);
    if (!hasMotion || !bowler?.id) return undefined;
    getMotionMeasurements(bowler.id).then((rows) => {
      if (alive) setMotionMeasurements(rows);
    });
    return () => {
      alive = false;
    };
  }, [hasMotion, bowler?.id, bowler?.updated_at]);
  const lastMotion = motionMeasurements && motionMeasurements.length > 0 ? motionMeasurements[0] : null;
  const measuredLabel = lastMotion
    ? new Date(lastMotion.createdAt).toLocaleDateString()
    : t("Never measured");
  const [showPhotoModal, setPhotoShowModal] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [showAlertHeader, setShowAlertHeader] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    if (errorMessage) {
      setShowAlert(true);
      setShowAlertMessage(errorMessage);
      setShowAlertHeader("WooCommerce Error");
    }
  }, [errorMessage]);

  useEffect(() => {
    if (!headerRef.current) return;
    const findScrollParent = (el) => {
      let node = el.parentElement;
      while (node && node !== document.body) {
        const overflowY = getComputedStyle(node).overflowY;
        if (overflowY === "auto" || overflowY === "scroll") return node;
        node = node.parentElement;
      }
      return window;
    };
    const target = findScrollParent(headerRef.current);
    let raf = 0;
    const getY = () =>
      target === window ? window.scrollY : target.scrollTop || 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        setCollapsed(getY() > 60);
        raf = 0;
      });
    };
    target.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      target.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);


  if (!bowler) return null;

  const getPhoto = getPhotoForUserId(userId);
  const photo = getPhoto(bowler.photo);
  const initials = `${(bowler.firstname || "?")
    .charAt(0)
    .toUpperCase()}${(bowler.lastname || "?").charAt(0).toUpperCase()}`;

  const posLink = posLinkLabel(bowler?.extra_values);

  const isLeftHanded = bowler.hand === "left_hander";
  const handLabel = isLeftHanded
    ? t("form.label.left_handed")
    : t("form.label.right_handed");

  const styleMap = {
    traditional: "form.label.traditional",
    two_handed: "form.label.two_handed",
    backup: "form.label.backup",
    helicopter_spinner: "form.label.helicopter_spinner",
    "full-roller": "form.label.full-roller",
    thumbless: "form.label.thumbless",
  };
  const styleLabel = t(
    styleMap[bowler.style || "traditional"] || "form.label.traditional"
  );

  const papUd = bowler.pap_u_d || bowler.pap_ud;
  const papValue = `${bowler.pap_h || "?"} × ${bowler.pap_v || "?"}${
    papUd ? ` ${papUd}` : ""
  }`;
  const papText = `PAP ${papValue}`;

  const tiltObj = idx_data_axistilt.find(
    (x) => x.tilt_measure === bowler.axis_tilt
  );
  const rotationValue = `${bowler.axis_rot || "?"}°`;
  const tiltValue = `${tiltObj ? tiltObj.tilt_deg : "?"}°`;

  const bs = bowler.ball_speed || "average";
  const rr = bowler.rev_rate || "average";
  const speedText = t(`form.label.${bs}`, bs);
  const revRateText = t(`form.label.${rr}`, rr);

  const contactParts = [bowler.telephone, bowler.email].filter(Boolean);
  const addressParts = [
    bowler.address,
    bowler.city,
    bowler.state,
    bowler.postal_code,
    bowler.country,
  ].filter(Boolean);

  const rightSlot = actions || children;

  return (
    <>
      <Header ref={headerRef}>
        <CustomerBlock>
          {photo ? (
            <Avatar src={photo} alt="" $collapsed={collapsed} />
          ) : (
            <AvatarFallback $collapsed={collapsed}>{initials}</AvatarFallback>
          )}
          <Info>
          <NameLine>
            <NameText>
              {bowler.lastname?.toUpperCase()}
              {bowler.firstname ? `, ${bowler.firstname}` : ""}
            </NameText>
            {!isReadOnly && (
              <IconButton
                onClick={() => setShowEditProfileModal(true)}
                title={t("form.label.bowler")}
                aria-label={t("form.label.bowler")}
              >
                <Pencil />
              </IconButton>
            )}
            {bowler?.id && (
              <IconButton
                onClick={() => navigate("/bowler/" + bowler.id)}
                title={t("form.label.bowler")}
                aria-label={t("form.label.bowler")}
              >
                <Person />
              </IconButton>
            )}
            {posLink && pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 && (
              <PosBadge title={`SpectrePOS customer #${posLink}`}>
                <CheckCircleFill />
                SpectrePOS
              </PosBadge>
            )}
            {posLink &&
              pluginSubscriptions.indexOf("SPECTRE_POS") >= 0 &&
              posOpenOrder &&
              posOpenOrder.customerId === bowler.id && (
                <OrderBadge
                  aria-label={`${t("spectrepos.open_order", "Open order")}${
                    posOpenOrder.items > 0 ? `: ${posOpenOrder.items}` : ""
                  }`}
                >
                  <Cart3 />
                  <OrderLabel>
                    {t("spectrepos.open_order", "Open order")}
                    {posOpenOrder.items > 0 ? " ·" : ""}
                  </OrderLabel>
                  {posOpenOrder.items > 0 ? posOpenOrder.items : null}
                </OrderBadge>
              )}
          </NameLine>
          {!collapsed &&
            (contactParts.length > 0 || addressParts.length > 0) && (
              <PrimaryLine>
                {contactParts.length > 0 && (
                  <PersonalLine>{contactParts.join(" · ")}</PersonalLine>
                )}
                {addressParts.length > 0 && (
                  <PersonalLine>{addressParts.join(", ")}</PersonalLine>
                )}
              </PrimaryLine>
            )}
          </Info>
        </CustomerBlock>
        <ChipsRow>
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            $alert={isLeftHanded}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={handLabel}
          >
            <ChipLabel>{t("Hand", "Hand")}</ChipLabel>
            <ChipValue $alert={isLeftHanded}>{handLabel}</ChipValue>
          </MetaChip>
          <ChipGroup>
            <MetaChip
              type="button"
              $readonly={isReadOnly}
              onClick={() => !isReadOnly && setShowBowlerData(true)}
              title={papText}
            >
              <ChipLabel>{t("PAP", "PAP")}</ChipLabel>
              <ChipValue>{papValue}</ChipValue>
            </MetaChip>
            {pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0 && (
              <IconButton
                onClick={() => papGetAuditRecords({ customerId: bowler.id })}
                title="PAP history"
                aria-label="PAP history"
              >
                <ClockHistory />
              </IconButton>
            )}
          </ChipGroup>
          {hasMotion && (
            <MetaChip
              type="button"
              onClick={() => setShowMotion(true)}
              title={t("Motion measurements")}
            >
              <ChipLabel>{t("Measured", "Measured")}</ChipLabel>
              <ChipValue>{measuredLabel}</ChipValue>
            </MetaChip>
          )}
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={styleLabel}
          >
            <ChipLabel>{t("Style", "Style")}</ChipLabel>
            <ChipValue>{styleLabel}</ChipValue>
          </MetaChip>
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={`${t("Rotation")} ${rotationValue}`}
          >
            <ChipLabel>{t("Rotation", "Rotation")}</ChipLabel>
            <ChipValue>{rotationValue}</ChipValue>
          </MetaChip>
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={`${t("Tilt")} ${tiltValue}`}
          >
            <ChipLabel>{t("Tilt", "Tilt")}</ChipLabel>
            <ChipValue>{tiltValue}</ChipValue>
          </MetaChip>
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={`${t("Speed")} ${speedText}`}
          >
            <ChipLabel>{t("Speed", "Speed")}</ChipLabel>
            <ChipValue>{speedText}</ChipValue>
          </MetaChip>
          <MetaChip
            type="button"
            $readonly={isReadOnly}
            onClick={() => !isReadOnly && setShowBowlerData(true)}
            title={`${t("Rev Rate")} ${revRateText}`}
          >
            <ChipLabel>{t("Rev Rate", "Rev Rate")}</ChipLabel>
            <ChipValue>{revRateText}</ChipValue>
          </MetaChip>
        </ChipsRow>
        {rightSlot && <Actions>{rightSlot}</Actions>}
        <CollapseTab
          onClick={() => setCollapsed((c) => !c)}
          title={collapsed ? t("Expand") : t("Collapse")}
          aria-label={collapsed ? t("Expand") : t("Collapse")}
        >
          {collapsed ? <ChevronDown /> : <ChevronUp />}
        </CollapseTab>
      </Header>

      {showEditProfileModal && (
        <UpdateProfile
          show={showEditProfileModal}
          onHide={() => setShowEditProfileModal(false)}
          bowler={bowler}
          showEditProfileModal={showEditProfileModal}
          setShowEditProfileModal={setShowEditProfileModal}
          isReadOnly={isReadOnly}
          setCustomer={setCustomer}
          woocommerceCheckUserExists={woocommerceCheckUserExists}
          woocommerceCreateCustomer={woocommerceCreateCustomer}
          woocommerceUpdateCustomer={woocommerceUpdateCustomer}
          image={photo}
          savingPhoto={savingPhoto}
          setPhotoShowModal={setPhotoShowModal}
          defaultImage={null}
          deleteCustomer={(id) => deleteCustomer && deleteCustomer({ id })}
          require_signature={
            pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0
              ? require_signature
              : false
          }
          require_email={require_email}
          require_phone={require_phone}
          pluginSubscriptions={pluginSubscriptions}
          current_woocommerce_id={current_woocommerce_id}
        />
      )}

      {showPhotoModal && (
        <PhotoSelect
          circle={true}
          show={showPhotoModal}
          onHide={() => setPhotoShowModal(false)}
          onFromCamera={(imageBase64) => {
            setCustomerPhoto({ imageBase64 });
            setPhotoShowModal(false);
          }}
          onFromCrop={(imageBase64) => {
            setCustomerPhoto({ imageBase64 });
            setPhotoShowModal(false);
          }}
          onFromGallery={(imageBase64) => {
            setCustomerPhoto({ imageBase64 });
            setPhotoShowModal(false);
          }}
          currentPhoto={photo}
          showDeleteButton={true}
          onDeleteButtonClick={() => {
            setShowConfirmDelete(true);
            setPhotoShowModal(false);
          }}
        />
      )}

      {showConfirmDelete && (
        <ConfirmDelete
          show={showConfirmDelete}
          onHide={() => setShowConfirmDelete(false)}
          onConfirmClick={() => {
            setCustomerPhoto({ imageBase64: "" });
            setShowConfirmDelete(false);
          }}
        />
      )}

      {showBowlerData && (
        <BowlerDataModal
          showData={showBowlerData}
          setShowData={setShowBowlerData}
          bowler={bowler}
          isReadOnly={isReadOnly}
          setCustomer={setCustomer}
          isRightHander={isRightHander}
          specsheetSVGClick={specsheetSVGClick}
        />
      )}

      <ModalSpecsheets />

      <ModalPAPAudit />

      <ModalMotionMeasurements

        show={showMotion}

        onHide={() => setShowMotion(false)}

        measurements={motionMeasurements || []}

      />
      <ModalUpdateError
        show={showAlert}
        onHide={() => {
          resetErrorMessage();
          setShowAlert(false);
        }}
        confirmDescription={showAlertMessage}
        confirmHeader={showAlertHeader}
      />
    </>
  );
};

export const BowlerHeader = connect(
  (state) => ({
    bowler: state.bowlers.selectedCustomer,
    userId: state.userSession.userData.id,
    isReadOnly: state.userSession.isReadOnly,
    pluginSubscriptions: state.plugin.pluginSubscriptions,
    posOpenOrder: state.plugin.pos_open_order,
    isRightHander: state.specsheet.currentSpecSheet
      ? state.specsheet.currentSpecSheet.hand === "right_hander"
      : true,
    savingPhoto: state.bowlers.savingPhoto,
    require_signature: state.plugin.plugin_settings.require_signature,
    require_email: state.settings.appSettings.bowlerPreferences.require_email,
    require_phone: state.settings.appSettings.bowlerPreferences.require_phone,
    current_woocommerce_id: state.plugin.plugin_settings.current_woocommerce_id,
    errorMessage: state.plugin.errorMessage,
  }),
  {
    setCustomer,
    papGetAuditRecords,
    deleteCustomer,
    setCustomerPhoto,
    woocommerceCheckUserExists,
    woocommerceCreateCustomer,
    woocommerceUpdateCustomer,
    resetErrorMessage,
    specsheetSVGClick,
  }
)(BowlerHeaderImpl);
